export const baseTariff = {
    id: "basic",
    nameKey: "main.landing.tariffs.plans.basic.name",
    audienceKey: "main.landing.tariffs.plans.basic.audience",
    price: 9900,
    descriptionKey: "main.landing.tariffs.plans.basic.description",
    featureKeys: [
        "main.landing.tariffs.plans.basic.features.legalEntities",
        "main.landing.tariffs.plans.basic.features.employees",
        "main.landing.tariffs.plans.basic.features.documents",
        "main.landing.tariffs.plans.basic.features.bidding",
        "main.landing.tariffs.plans.basic.features.activeDeliveries",
        "main.landing.tariffs.plans.basic.features.reports",
        "main.landing.tariffs.plans.basic.features.notifications",
        "main.landing.tariffs.plans.basic.features.storage",
    ],
};

export const forwarderTariff = {
    id: "forwarder-pro",
    nameKey: "main.landing.tariffs.plans.forwarder.name",
    audienceKey: "main.landing.tariffs.plans.forwarder.audience",
    price: 15900,
    descriptionKey: "main.landing.tariffs.plans.forwarder.description",
    featureKeys: [
        "main.landing.tariffs.plans.forwarder.features.basicPlan",
        "main.landing.tariffs.plans.forwarder.features.multiAccount",
        "main.landing.tariffs.plans.forwarder.features.gosLog",
    ],
};

export const tariffAddons = [
    {
        id: "reduction",
        nameKey: "main.landing.tariffs.addons.reduction.name",
        descriptionKey: "main.landing.tariffs.addons.reduction.description",
        price: 5900,
    },
    {
        id: "multimodal",
        nameKey: "main.landing.tariffs.addons.multimodal.name",
        descriptionKey: "main.landing.tariffs.addons.multimodal.description",
        price: 7900,
    },
    {
        id: "time-windows",
        nameKey: "main.landing.tariffs.addons.timeWindows.name",
        descriptionKey: "main.landing.tariffs.addons.timeWindows.description",
        price: 7900,
    },
    {
        id: "unlimited-deliveries",
        nameKey: "main.landing.tariffs.addons.unlimitedDeliveries.name",
        descriptionKey: "main.landing.tariffs.addons.unlimitedDeliveries.description",
        price: 10900,
    },
    {
        id: "extended-roles",
        nameKey: "main.landing.tariffs.addons.extendedRoles.name",
        descriptionKey: "main.landing.tariffs.addons.extendedRoles.description",
        price: 3900,
    },
    {
        id: "api",
        nameKey: "main.landing.tariffs.addons.api.name",
        descriptionKey: "main.landing.tariffs.addons.api.description",
        price: 15900,
    },
    {
        id: "tracking",
        nameKey: "main.landing.tariffs.addons.tracking.name",
        descriptionKey: "main.landing.tariffs.addons.tracking.description",
        price: 6900,
    },
    {
        id: "cross-docking",
        nameKey: "main.landing.tariffs.addons.crossDocking.name",
        descriptionKey: "main.landing.tariffs.addons.crossDocking.description",
        price: 10900,
    },
    {
        id: "analytics",
        nameKey: "main.landing.tariffs.addons.analytics.name",
        descriptionKey: "main.landing.tariffs.addons.analytics.description",
        price: 3900,
    },
];

export const trialPeriod = {
    durationKey: "main.landing.tariffs.trial.duration",
    titleKey: "main.landing.tariffs.trial.title",
    descriptionKey: "main.landing.tariffs.trial.description",
};
